export default __webpack_public_path__ + "static/media/kemi.9b077fb0.jpg";